import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import React from "react";
import { useFormContext } from "react-hook-form";
import type { DealCompanySetting } from "~/models/CompanySetting";
import { convertToComboBoxOption } from "~/models/CompanySetting";
import type { DealSearchCondition } from "~/models/Deal";

type Props = {
	handleChangeMaintenanceCompanyInput: (inputText: string) => void;
	maintenanceCompanies: DealCompanySetting[] | null;
	onChangeCompanyMasterId: (
		companyMasterId: number | undefined
	) => Promise<void>;
	selectedCompanyMasterId: number | undefined;
};

export const MaintenanceCompanyCombobox: React.FC<Props> = ({
	handleChangeMaintenanceCompanyInput,
	selectedCompanyMasterId,
	maintenanceCompanies,
	onChangeCompanyMasterId
}: Props) => {
	const { setValue } = useFormContext<DealSearchCondition>();
	const selectedMaintenanceCompany =
		maintenanceCompanies?.find(
			({ companyMasterId }) => companyMasterId === selectedCompanyMasterId
		) || null;
	const onChangeOption = React.useCallback(
		async (
			option: ComponentProps<typeof SingleComboBox>["value"] | null
		): Promise<void> => {
			const companyMasterId = option ? Number(option.value) : undefined;
			setValue("companyMasterId", companyMasterId);
			await onChangeCompanyMasterId(companyMasterId);
		},
		[onChangeCompanyMasterId, setValue]
	);
	return (
		<SingleComboBox
			defaultValue={
				selectedMaintenanceCompany
					? convertToComboBoxOption(selectedMaintenanceCompany)
					: null
			}
			onChange={onChangeOption}
			onInputChange={handleChangeMaintenanceCompanyInput}
			options={
				maintenanceCompanies?.map((cs: DealCompanySetting) =>
					convertToComboBoxOption(cs)
				) || []
			}
			placeholder="管理会社"
		/>
	);
};
